import style from "./SuccessView.module.scss";
import { useHistory } from "react-router-dom";
import checkIcon from "assets/images/rimac-check-circle-filled.svg";
import defaultImage from "assets/images/default_product.png";

export const SuccessView = ({ tags, title }) => {
  const history = useHistory();

  const handleFinish = () => {
    history.push(`/admin/more-options-tags`);
  };

  return (
    <article className={style.successView}>
      <header>
        <img src={checkIcon} draggable={false} />
        <h3>{title}</h3>
      </header>

      <div className={style.infoGroup}>
        {tags.map((item, i) => (
          <div key={i}>
            <section className={style.itemTagsGroupProduct}>
              <div className={style.itemTagsGroupProductInfo}>
                <img src={item?.image || defaultImage} draggable={false} />
                <div>
                  <h4>{item.name}</h4>
                  <p>SKU {item.sku}</p>
                </div>
              </div>
              <span>{item?.tags.length} Tags</span>
            </section>
            <section className={style.itemTagsGroupTags}>
              {item?.tags.map((tag, i) => (
                <p key={i}>{tag.rfid}</p>
              ))}
            </section>
          </div>
        ))}
      </div>

      <footer>
        <button onClick={handleFinish}>Finalizar</button>
      </footer>
    </article>
  );
};
